import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputAdornment,
  TextField,
  Paper,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import Utils from '../../share/Utils';

const styles = theme => ({
  dialogTitleTypography: {
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    display: 'inline',
    fontSize: 23
  },
  dialogTitle: {
    display: 'inline-flex',
  },
  paperTable: {
    // maxHeight: '35vh'
  },
  formControlValor: {
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(0.5),
    width: 400,
  },
  invisible: {
    display: 'none',
  },
  typographyObs: {
    fontSize: 12,
    marginTop: theme.spacing(2),
  }
});

class FormDialogValor extends React.Component {
  utils = new Utils();
  state = {
    valorTaxa: '',
    valorIndice: '',
    valorTabelaInicial: '',
    valorTabelaFinal: '',
    errorMessageValorTaxa: '',
    errorMessageValorIndice: '',
    errorMessageValorTabelaInicial: '',
    errorMessageValorTabelaFinal: ''
  }

  handleClose = () => {
    this.props.handleClose();
  }

  handleClickSave = async () => {
    let brancoAcoes = '';
    let codItemTaxa = 0;

    let valorTaxaCadastroExtract = [];
    let valorTaxa = this.state.valorTaxa;
    let valorIndice = this.state.valorIndice;
    let valorTabelaInicial = this.state.valorTabelaInicial;
    let valorTabelaFinal = this.state.valorTabelaFinal;

    valorTaxaCadastroExtract.push(Object.values({
      valorTaxa, 
      valorIndice, 
      valorTabelaInicial, 
      valorTabelaFinal, 
      brancoAcoes,
      codItemTaxa})
      );
    this.props.handleSave(valorTaxaCadastroExtract);
  }  

  handleChangeTextField = event => {
    var valorNovo = '';    

    if (event.target.name === 'valorTaxa') {
      valorNovo = event.target.value.toString().replace(/[^0-9,-]/g, '').substring(0, 8);
      this.setState({ [event.target.name]: valorNovo, errorMessageValorTaxa: '' });
    }
    if (event.target.name === 'valorIndice') {
      valorNovo = event.target.value.toString().replace(/[^0-9,]/g, '').substring(0, 8);
      this.setState({ [event.target.name]: valorNovo, errorMessageValorIndice: '' });
    }
    if (event.target.name === 'valorTabelaInicial') {
      valorNovo = event.target.value !== '' ? this.utils.formataValorNegativo(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: valorNovo, errorMessageValorTabelaInicial: '' });
    }
    if (event.target.name === 'valorTabelaFinal') {
      valorNovo = event.target.value !== '' ? this.utils.formataValorNegativo(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: valorNovo, errorMessageValorTabelaFinal: '' });
    }
  };

  handleBlurValorTaxa = () => {
    if (this.state.valorTaxa === '' || this.state.valorTaxa === null || this.state.valorTaxa === undefined) {
      this.setState({errorMessageValorTaxa: 'Favor preencher o valor da taxa'});
    } else {
      var valorTaxa = this.state.valorTaxa.replace('-', '');
      var qtdeVirgulas = valorTaxa.split(',').length - 1;
      if(qtdeVirgulas > 1) {
        this.setState({valorTaxa: '', errorMessageValorTaxa: 'Número inválido'});
      }
      if(qtdeVirgulas === 1){
        var valorSplit = valorTaxa.split(',');
        var valorInteiro = Number(valorSplit[0]);
        var valorFracao = Number(valorSplit[1]);
        if (valorInteiro > 100) {
          this.setState({valorTaxa: '', errorMessageValorTaxa: 'Valor maior que 100%'});
        }
        if (valorFracao > 99) {
          this.setState({valorTaxa: '', errorMessageValorTaxa: 'Valor com mais que 2 casas decimais'});
        }
      }
      if(qtdeVirgulas === 0){
        if (valorTaxa > 100) {
          this.setState({valorTaxa: '', errorMessageValorTaxa: 'Valor maior que 100%'});
        }
      }
    }
  } 
  handleBlurValorIndice = () => {
    if (this.state.valorIndice === '' || this.state.valorIndice === null || this.state.valorIndice === undefined) {
      this.setState({errorMessageValorIndice: 'Favor preencher o valor do índice'});
    } else {
      var valorIndice = this.state.valorIndice.replace('-', '');
      var qtdeVirgulas = valorIndice.split(',').length - 1;
      if(qtdeVirgulas > 1) {
        this.setState({valorIndice: '', errorMessageValorIndice: 'Número inválido'});
      }
      if(qtdeVirgulas === 1){
        var valorSplit = valorIndice.split(',');
        var valorInteiro = Number(valorSplit[0]);
        var valorFracao = Number(valorSplit[1]);
        if (valorInteiro > 0 && valorFracao > 0) {
          this.setState({valorIndice: '', errorMessageValorIndice: 'Valor maior que 1'});
        }
        if (valorFracao > 9999) {
          this.setState({valorIndice: '', errorMessageValorIndice: 'Valor com mais que 4 casas decimais'});
        }
      }
      if(qtdeVirgulas === 0){
        if (valorTaxa > 1) {
          this.setState({valorIndice: '', errorMessageValorIndice: 'Valor maior que 1'});
        }
      }
    }
  } 
  handleOnFocus = event => {
    if (event.target.name === 'valorTaxa') {
      this.setState({errorMessageValorTaxa: ''});
    }
    if (event.target.name === 'valorIndice') {
      this.setState({errorMessageValorIndice: ''});
    }
    if (event.target.name === 'valorTabelaInicial') {
      this.setState({errorMessageValorTabelaInicial: ''});
    }
    if (event.target.name === 'valorTabelaFinal') {
      this.setState({errorMessageValorTabelaFinal: ''});
    }
  }

  handleBlurValorTabelaInicial = () => {
    if (this.state.valorTabelaInicial === '' || this.state.valorTabelaInicial === null || this.state.valorTabelaInicial === undefined) {
      this.setState({errorMessageValorTabelaInicial: 'Favor preencher o valor'});
    }
  }  
  handleBlurValorTabelaFinal = () => {
    if (this.state.valorTabelaFinal === '' || this.state.valorTabelaFinal === null || this.state.valorTabelaFinal === undefined) {
      this.setState({errorMessageValorTabelaFinal: 'Favor preencher o valor'});
    } else {
      if (Number(this.state.valorTabelaFinal.replace('.', '').replace(',', '.')) 
         < 
         Number(this.state.valorTabelaInicial.replace('.', '').replace(',', '.'))){        
        this.setState({errorMessageValorTabelaFinal: 'Valor final menor que valor inicial'});
      }
    }
  }  

  isSalvarDisabled = () => {
      return (
         ((this.state.errorMessageValorIndice !== '' ||
        this.state.valorIndice === undefined ||
        this.state.valorIndice === 0 ||
        this.state.valorIndice === '') && this.props.isIndice) ||

        ((this.state.errorMessageValorTaxa !== '' ||
        this.state.valorTaxa === undefined ||
        this.state.valorTaxa === 0 ||
        this.state.valorTaxa === '') && !this.props.isIndice) ||

        (this.state.errorMessageValorTabelaInicial !== '' ||
        this.state.valorTabelaInicial === undefined ||
        this.state.valorTabelaInicial === 0 ||
        this.state.valorTabelaInicial === '') ||
        (this.state.errorMessageValorTabelaFinal !== '')
      );
  }
  
  render () {

    const { open, titulo, classes, isIndice } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='sm'
          scroll='body'
          fullWidth
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Typography className={classes.dialogTitleTypography}>{titulo}</Typography> 
          </DialogTitle>
          <DialogContent>
              <Paper className={classes.paperTable}>
                <FormControl className={isIndice ? classes.invisible : classes.formControlValor}>
                  <TextField
                    value={this.state.valorTaxa}                  
                    margin='dense'
                    id='valorTaxa'
                    name='valorTaxa'
                    error={this.state.errorMessageValorTaxa !== ''}
                    label={this.state.errorMessageValorTaxa !== '' ? this.state.errorMessageValorTaxa : '*Valor Taxa'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValorTaxa}
                    onFocus={this.handleOnFocus}
                    InputProps={{
                      endAdornment: <InputAdornment position='end'>%</InputAdornment>
                    }}
                  />
                </FormControl>
                <FormControl className={!isIndice ? classes.invisible : classes.formControlValor}>
                  <TextField
                    value={this.state.valorIndice}                  
                    margin='dense'
                    id='valorIndice'
                    name='valorIndice'
                    error={this.state.errorMessageValorIndice !== ''}
                    label={this.state.errorMessageValorIndice !== '' ? this.state.errorMessageValorIndice : '*Valor Índice'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValorIndice}
                  />
                </FormControl>
                <FormControl className={classes.formControlValor}>
                  <TextField
                    value={this.state.valorTabelaInicial}                  
                    margin='dense'
                    id='valorTabelaInicial'
                    name='valorTabelaInicial'
                    error={this.state.errorMessageValorTabelaInicial !== ''}
                    label={this.state.errorMessageValorTabelaInicial !== '' ? this.state.errorMessageValorTabelaInicial : '*Valor de Tabela Inicial'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValorTabelaInicial}
                    onFocus={this.handleOnFocus}
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControlValor}>
                  <TextField
                    value={this.state.valorTabelaFinal}                  
                    margin='dense'
                    id='valorTabelaFinal'
                    name='valorTabelaFinal'
                    error={this.state.errorMessageValorTabelaFinal !== ''}
                    label={this.state.errorMessageValorTabelaFinal !== '' ? this.state.errorMessageValorTabelaFinal : 'Valor de Tabela Final'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValorTabelaFinal}
                    onFocus={this.handleOnFocus}
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
              </Paper>        
              {isIndice &&
              <Typography className={classes.typographyObs}>
              o valor vigente de tabela do item para se obter o valor máximo que poderá ser cobrado pelo prestador (valor de tabela / índice = valor máximo)
              </Typography>}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              onClick={this.handleClickSave}
              disabled={this.isSalvarDisabled()}
              color='primary'>
              Adicionar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogValor);
